import { getAllowedQuantity } from '@/helpers/getAllowedQuantity'
import { isProductNonStockAndPhased } from '@/helpers/isProductNonStockAndPhased'

import type { OrderEntry } from '@/gen/ecom/models'

interface Params {
  appropriations?: Parameters<typeof getAllowedQuantity>[0]['appropriations']
  cartEntries?: OrderEntry[]
  productCode?: string
  quantity?: number
  productStock?: string | null
  productPartStatus?: string | null
}

export interface AddToCartState {
  allowedQuantity: number
  isDisabled: boolean
}

/**
 * Pure add-to-cart button state. Kept hook-free so list rows can compute it from data passed
 * down by the list (one cart/appropriations subscription for the whole list instead of one per
 * row); `useAddToCartState` wraps it for standalone call sites.
 */
export function getAddToCartState({
  appropriations,
  cartEntries,
  productCode,
  quantity,
  productStock,
  productPartStatus,
}: Params): AddToCartState {
  const cartProductQuantity = cartEntries?.find((entry) => entry.product?.code === productCode)?.quantity ?? 0

  const allowedQuantity = getAllowedQuantity({
    appropriations,
    productCode,
    cartProductQuantity,
  })

  const isDisabled =
    isProductNonStockAndPhased(productStock, productPartStatus) ||
    quantity === 0 ||
    quantity === cartProductQuantity ||
    (quantity ?? 0) > allowedQuantity

  return { allowedQuantity, isDisabled }
}
